<template>
    <div>
        <div class="form-group">
            <div class="row">
                <div class="col-lg-8">
                    <map-autocomplete-single
                        label="Partenza"
                        ref="mapsAutocompleteFrom"
                        id="maps_autocomplete_from"
                        name="source_address"
                        latitude-name="source_lat"
                        longitude-name="source_lng"
                        @placeCleared="placeFromCleared"
                        @placeSelected="placeFromSelected"
                        :pos="from"
                        :read-only="readOnly"
                        required
                    />
                </div>
                <div class="col-lg-4">
                    <form-input
                        label="Note"
                        name="source_stop_details"
                        :value="getNotes('from')"
                        :readonly="readOnly"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-8">
                    <map-autocomplete-single
                        label="Destinazione"
                        ref="mapsAutocompleteTo"
                        id="maps_autocomplete_to"
                        name="destination_address"
                        latitude-name="destination_lat"
                        longitude-name="destination_lng"
                        @placeCleared="placeToCleared"
                        @placeSelected="placeToSelected"
                        :read-only="readOnly"
                        :pos="to"
                        required
                    />
                </div>
                <div class="col-lg-4">
                    <form-input
                        label="Note"
                        name="destination_stop_details"
                        :value="getNotes('to')"
                        :readonly="readOnly"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({
        from: null,
        to: null
    }),
    props: {
        mapRef: {
            type: String,
            default: "map",
            required: false
        },
        fromStop: {
            type: Object,
            default: () => ({}),
            required: false
        },
        toStop: {
            type: Object,
            default: () => ({}),
            required: false
        },
        refCompute: {
            type: String,
            default: "",
            required: false
        },
        readOnly: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {},
    computed: {},
    methods: {
        getNotes: function(source) {
            return !!this[source] ? this[source].notes : "";
        },
        placeFromCleared: function(position) {
            this.from = null;
            this.placeCleared("from");
        },
        placeFromSelected: function(position) {
            this.placeSelected("from", position);
        },
        placeToCleared: function(position) {
            this.to = null;
            this.placeCleared("to");
        },
        placeToSelected: function(position) {
            this.placeSelected("to", position);
        },
        placeSelected: function(source, position) {
            this.placeCleared(source);
            this[source] = {
                address: position.address,
                formatted_address: position.formatted_address,
                lat: position.lat,
                lng: position.lng
            };
            if (!!this.mapRef) {
                this.$root.$refs[this.mapRef].addMarker(source, this[source]);
            }
            if (
                !!this.from &&
                !this.emptyObject(this.from) &&
                !!this.to &&
                !this.emptyObject(this.to)
            ) {
                this.$root.calculateDistanceMatrix(
                    this.from,
                    this.to,
                    this.refCompute
                );
                this.$root.calculateDistanceMatrixTrafficPessimistic(
                    this.from,
                    this.to,
                    this.refCompute
                );
                this.$root.$refs[this.mapRef].addDirection("from", "to");
            }
        },
        placeCleared: function(source) {
            this.$root.$refs[this.mapRef].removeMarker(source);
            this.$root.$refs[this.mapRef].removeDirection("from", "to");
        },
        onMapReady: function() {
            if (!!this.mapRef) {
                if (!this.emptyObject(this.from))
                    this.placeFromSelected(this.from);
                if (!this.emptyObject(this.to)) this.placeToSelected(this.to);
            }
        }
    },
    created: function() {
        if (!this.emptyObject(this.fromStop))
            this.from = this.stopToMapObject(this.fromStop);
        if (!this.emptyObject(this.toStop))
            this.to = this.stopToMapObject(this.toStop);
    },
    mounted: function() {}
};
</script>
